import { CreateContextInputDto, CreateContextOutputDtoSingleOutputMessage } from '@api/consumerloans-public-api';
import { UseFetchInputOnSuccess } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';
import { PortalCommunicationHelper } from '@bcp-channels-sharedcomponents-reactjs/utils';
import { useGetValueByCreditType } from '@hooks';
import { useFetchCreateContext } from '@services';

export interface RedirectWithContextParams {
	amount: number;
	term: number;
	goToPrivateSimulator?: boolean;
	callback?: () => void;
}

export const useRedirectWithContext = (): {
	navigate: (props: RedirectWithContextParams) => void;
} => {
	const { fetch: fetchCreateContext } = useFetchCreateContext();

	const localId = useGetValueByCreditType(
		{
			AL: 'ALSimulator',
			RENEN: 'RENENSimulator',
			HOME: 'HOMESimulator',
		},
		'CLSimulator'
	);

	const navigate = ({ amount, term, goToPrivateSimulator = true, callback }: RedirectWithContextParams) => {
		fetchCreateContext({
			journeyData: { amount, term },
			origin: 'public-simulator',
		})
			.then((res: UseFetchInputOnSuccess<CreateContextInputDto, CreateContextOutputDtoSingleOutputMessage>) => {
				PortalCommunicationHelper.doNavigation({
					data: {
						localId: localId,
						journeyData: { ctxId: res?.data?.contextIdentifier },
						goToPrivate: goToPrivateSimulator,
					},
				});
			})
			.finally(() => {
				callback?.();
			});
	};

	return { navigate };
};
